/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { FilterButtonSVG } from "../../../../assets/SVGs/FilterButtonSVG";
import { MenuItem } from "primereact/menuitem";
import { ProgressSpinner } from "primereact/progressspinner";
import DataTableComponent, { ColumnOption } from "../../../common/DataTable";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { InputText } from "primereact/inputtext";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import axios from "../../../../util/axiosconfig";
import { useDebounce } from "../../../../util/debounce";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { SORT_FILTER, STATUS_FILTER } from "../../../../util/constants";
import { RadioButton } from "primereact/radiobutton";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import FilterButton from "../common/FilterButton";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { convertEpochtoDate } from "../../../../helper/DateConverters";
interface Department {
  departmentID?: string | null;
  name: string | null;
  description: string | null;
  manager: any;
  isActive: boolean;
  departmentStatusChangeHistory?: any[];
}

interface Filters {
  name: string | null;
  manager: string | null;
  status: "all" | "active" | "inactive";
}

interface FormErrors {
  name: string | null;
  description: string | null;
  manager: string | null;
}

const DepartmentManagement = () => {
  const [departmentsLoading, setDepartmentsLoading] = useState<boolean>(false);
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>("add");
  const [departments, setDepartments] = useState<Department[]>([]);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string | null>("all");
  const page = 0;

  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "createdDate",
    sortOrder: false,
  });

  const [isStatusDialogVisible, setIsStatusDialogVisible] =
    useState<boolean>(false);
  const [statusChangeReason, setStatusChangeReason] = useState<string>("");
  const [pendingStatusChange, setPendingStatusChange] = useState<{
    departmentID: any;
    isActive: boolean;
  } | null>(null);
  const [statusChangeReasonError, setStatusChangeReasonError] = useState<
    string | null
  >(null);

  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);
  const [departmentStatusChangeActivity, setDepartmentStatusChangeActivity] =
    useState<any>([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [filters, setFilters] = useState<Filters>({
    name: null,
    manager: null,
    status: "all",
  });

  const searchDepartmentNameWithDebounce = useDebounce(
    filters?.name?.trim() ?? null
  );
  const searchManagerWithDebounce = useDebounce(
    filters?.manager?.trim() ?? null
  );

  const [formValues, setFormValues] = useState<Department>({
    name: null,
    description: null,
    manager: null,
    isActive: true,
  });

  const [formErrors, setFormErrors] = useState<FormErrors>({
    name: null,
    description: null,
    manager: null,
  });

  const [managers, setManagers] = useState<string[]>([]);
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const fetchDepartments = async (
    page: number,
    size: number,
    type?: string
  ) => {
    try {
      setDepartmentsLoading(true);
      const params: any = {
        size,
        page,

        sortField: sortFilter.sortField,
        sortOrder:
          sortFilter.sortOrder === true ? SORT_FILTER.ASC : SORT_FILTER.DESC,
      };
      if (statusFilter !== "all") {
        params.isActive = statusFilter === "active" ? true : false;
      }
      if (searchDepartmentNameWithDebounce) {
        params.name = searchDepartmentNameWithDebounce;
      }
      if (searchManagerWithDebounce) {
        params.manager = searchManagerWithDebounce;
      }
      // const response = await axios.get(`tl-admin/department/all`, { params });
      // setTotalRecords(response.data.totalRecords);
      // setDepartments(response.data.result);
      if (type === "export") {
        try {
          setIsExporting(true);
          const response = await axios.get("tl-admin/export-department", {
            params,
            responseType: "blob", // Important for binary data
          });

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.download = "department_report.csv";

          // Append to body and trigger download
          document.body.appendChild(link);
          link.click();

          // Clean up
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (error) {}
      } else {
        setDepartmentsLoading(true);
        const response = await axios.get("tl-admin/department/all", { params });
        setDepartments(response.data.result);
        setTotalRecords(response.data.totalRecords); // Assuming the API returns the total count
      }
      setIsExporting(false);
      setDepartmentsLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      setDepartmentsLoading(false);
      showError(error, toast);
    }
  };

  // const fetchUsers = async () => {
  //   try {
  //     // setLoading(true);
  //     const response = await axios.get("tl-admin/line-manager/list");
  //     setManagers(response.data.result);
  //     // setLoading(false);
  //   } catch (err) {
  //     const error = getErrorMessage(err);
  //     showError(error, toast);
  //     // setLoading(false);
  //   }
  // };

    const fetchUsers = async () => {
    try {
      // setLoading(true);
      const response = await axios.get("tl-admin/timelog-users/list");
      setManagers(response.data.result);
      // setLoading(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    setFirst(page);
    fetchDepartments(page, size);
  }, [
    searchDepartmentNameWithDebounce,
    searchManagerWithDebounce,
    sortFilter,
    statusFilter,
  ]);

  // [
  //   "Olivia Johnson",
  //   "Noah Williams",
  //   "Isabella Brown",
  //   "Ethan Davis",
  //   "Mia Wilson",
  // ]

  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records

  const menu = useRef<Menu>(null);
  const toast = useRef<Toast>(null);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchDepartments(currentPage, event.rows);
  };

  const headerTemplate = (header: string, field: string) => {
    return (
      <div
        className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
          field !== "" && "tw-cursor-pointer"
        }`}
        onClick={() => {
          if (field !== "") {
            setSortFilter((prevSortFilter: any) => ({
              ...prevSortFilter,
              sortField: field,
              sortOrder: !prevSortFilter.sortOrder,
            }));
          }
        }}
      >
        <span className="tw-font-bold">{header}</span>
        {field !== "" && (
          <span className="tw-ml-4 tw-mr-0">
            <TableSortingSVG />
          </span>
        )}
      </div>
    );
  };

  const validateForm = (type?: string) => {
    const errors: Partial<Record<string, string>> = {};

    if (!formValues.name || formValues.name.trim() === "") {
      errors.name = "Department name is required";
    }
    // if (!formValues.manager) {
    //   errors.manager = "Manager is required";
    // }
    if (!formValues.description || formValues.description.trim() === "") {
      errors.description = "Capacity is required";
    }
    setFormErrors((prev) => ({ ...prev, ...errors }));

    return Object.keys(errors).length === 0; // Returns true if no errors
  };

  const handleAddUpdateDepartment = async () => {
    if (!validateForm()) return; // Stop submission if validation fails
    try {
      setIsAddButtonDisabled(true);
      const departmentData: any = {};
      if (formType === "update") {
        departmentData.departmentID = formValues?.departmentID;
      }
      departmentData.name = formValues?.name?.trim();
      departmentData.description = formValues?.description?.trim();
      departmentData.managerID = formValues?.manager?.userID;

      formType === "add"
        ? await axios.post("tl-admin/add-department", departmentData)
        : await axios.post("tl-admin/edit-department", departmentData);
      setFormValues({
        name: null,
        manager: null,
        description: null,
        isActive: formType === "add" ? true : formValues.isActive,
      });
      setFirst(page);
      setFirst(page);
      fetchDepartments(page, size);
      setIsDialogVisible(false);
      setIsAddButtonDisabled(false);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
    }
  };

  const updateDepartmentStatus = async (
    departmentID: any,
    isActive: boolean,
    reason: string
  ) => {
    try {
      setIsAddButtonDisabled(true);
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        departmentID,
      }));
      const statusResponse = await axios.post("tl-admin/edit-department", {
        departmentID,
        isActive,
        statusChangeReason: reason,
      });
      if (statusResponse.status === 200) {
        showSuccess(statusResponse.data.Message, toast);
        const updatedDepartments = departments.map((department) =>
          department.departmentID === departmentID
            ? { ...department, isActive: isActive }
            : department
        );
        setDepartments(updatedDepartments);
      } else {
        setIsAddButtonDisabled(false);
      }
      setIsAddButtonDisabled(false);
      // Reset status change states
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    } catch (err) {
      const error = getErrorMessage(err);
      showError(error, toast);
      setIsAddButtonDisabled(false);
      setIsStatusDialogVisible(false);
      setStatusChangeReason("");
      setPendingStatusChange(null);
    }
  };

  const handleEditDepartment = (rowData: Department) => {
    setFormType("update");
    setFormValues(rowData);
    setIsDialogVisible(true);
  };

  const handleStatusChangeClick = (
    departmentID: any,
    currentStatus: boolean
  ) => {
    setPendingStatusChange({
      departmentID,
      isActive: !currentStatus,
    });
    setStatusChangeReason("");
    setIsStatusDialogVisible(true);
  };

  const confirmStatusChange = () => {
    if (!statusChangeReason.trim()) {
      setStatusChangeReasonError(
        "Please provide a reason for the status change"
      );
      return;
    }
    setStatusChangeReasonError(null);
    if (pendingStatusChange) {
      updateDepartmentStatus(
        pendingStatusChange.departmentID,
        pendingStatusChange.isActive,
        statusChangeReason
      ).then(() => {
        fetchDepartments(page, size);
        setIsStatusDialogVisible(false);
      });
    }
  };

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-UK", { month: "short" });
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${day} ${month} ${year}, ${hours}:${minutes}`;
  };

  const events: any = departmentStatusChangeActivity?.map((activity: any) => ({
    actionTakerID: activity?.actionTakerID,
    date: activity?.createdDate,
    actionTakerDisplayName: activity?.actionTakerName,
    comment: activity?.statusChangeReason,
    action:
      activity?.previousStatus && activity?.newStatus
        ? `Status changed from ${
            activity.previousStatus.charAt(0).toUpperCase() +
            activity.previousStatus.slice(1).toLowerCase()
          } to ${
            activity.newStatus.charAt(0).toUpperCase() +
            activity.newStatus.slice(1).toLowerCase()
          }`
        : null,
    id: activity?.id,
    previousStatus: activity?.previousStatus,
    newStatus: activity?.newStatus,
  }));

  const customizedMarker = () => (
    <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
      <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
    </div>
  );

  const customizedContent = (item: any) =>
    item?.action ? (
      <Card className="activity-card tw-bg-gray-50">
        <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
          <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {formatCreatedDate(item?.date)}
          </span>
        </div>
        <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          <span>
            <span className="tw-font-medium tw-text-gray-700">
              {item?.action}
            </span>{" "}
            <span className="tw-text-gray-600">
              by {item?.actionTakerDisplayName}
            </span>
          </span>
        </span>
        <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
          <span className="tw-ml-auto">{item?.comment}</span>
        </div>
      </Card>
    ) : (
      <div>No History Found</div>
    );

  const actionBodyTemplate = (rowData: Department) => (
    <div className="tw-flex tw-gap-4">
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto"
        onClick={() => handleEditDepartment(rowData)}
      >
        <EditButtonSVG />
      </Button>
      <InputSwitch
        checked={rowData.isActive}
        onChange={(e: InputSwitchChangeEvent) => {
          handleStatusChangeClick(rowData.departmentID, rowData.isActive);
        }}
        disabled={
          isAddButtonDisabled &&
          rowData.departmentID === formValues.departmentID
        }
      />
      <Button
        className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto focus:tw-shadow-none"
        onClick={() => {
          setDepartmentStatusChangeActivity(
            rowData?.departmentStatusChangeHistory || []
          );
          setSelectedRowData(rowData);
          setViewHistoryPopup(true);
        }}
        tooltip="View Status History"
        tooltipOptions={{ position: "top" }}
      >
        <i className="pi pi-info-circle tw-text-[#00AFEE] tw-text-xl"></i>
      </Button>
    </div>
  );

  const departmentColumns: ColumnOption[] = [
    {
      field: "name",
      header: headerTemplate("Department Name", "name"),
      visible: true,
    },
    {
      field: "description",
      header: headerTemplate("Description", "description"),
      visible: true,
    },
    {
      field: "manager",
      header: headerTemplate("Manager", "manager"),
      visible: true,
    },
    {
      field: "action",
      header: headerTemplate("Action", ""),
      body: actionBodyTemplate,
      visible: true,
    },
  ];

  const clearFilters = () => {
    setStatusFilter("all");
    setFilters({ name: null, manager: null, status: "all" });
  };

  const items = [
    {
      items: [
        {
          template: (
            <div>
              <label htmlFor="capacity" className="tw-ml-5">
                Department Name
              </label>
              <div className="tw-flex tw-gap-2 tw-items-center tw-mx-5 tw-w-62 tw-mt-2">
                <InputText
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-w-full tw-h-11"
                  value={filters?.name ?? ""}
                  placeholder="Enter Department Name"
                  onChange={(e) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      name: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-mt-3">
              <label htmlFor="capacity" className="tw-ml-5">
                Manager
              </label>
              <div className="tw-flex tw-gap-2 tw-items-center tw-mx-5 tw-w-62 tw-mt-2">
                <InputText
                  type="text"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-w-full tw-h-11"
                  value={filters?.manager ?? ""}
                  placeholder="Enter Manager Name"
                  onChange={(e) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      manager: e.target.value,
                    }));
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-mx-7 tw-w-62 tw-mt-5 tw-mb-3">
              {STATUS_FILTER.map((status) => (
                <div key={status.id} className="tw-flex tw-items-center">
                  <RadioButton
                    key={status.id}
                    inputId={status.id}
                    value={status.value}
                    checked={statusFilter === status.value}
                    onChange={(e) =>
                      setStatusFilter(e.value as "all" | "active" | "inactive")
                    }
                  />
                  <label htmlFor={status.id} className="tw-ml-1">
                    {status.label}
                  </label>
                </div>
              ))}
            </div>
          ),
        },
        {
          template: (
            <div className="tw-flex tw-flex-col tw-gap-2 tw-mx-5 tw-w-62 tw-mt-3 tw-mb-4">
              <Button
                className="tw-flex tw-px-3 tw-py-2 tw-rounded tw-bg-red-500 hover:tw-bg-red-500 tw-font-medium tw-gap-2 tw-text-white"
                onClick={clearFilters} // This function will reset filters
              >
                Clear Filters
              </Button>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      <div className="card">
        <div className="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-4 tw-bg-[#F8FAFC] tw-p-4 tw-mr-4">
          <h1 className="tw-font-bold tw-text-xl">Department Listing</h1>

          <div className="tw-flex tw-gap-2 focus:tw-shadow-none">
            <FilterButton menu={menu} />
            <Menu
              className="tw-w-72"
              model={items as MenuItem[]}
              popup
              ref={menu}
            />
            <Button
              className="tw-flex tw-px-3 tw-py-2 hover:tw-bg-[#02a2db] focus:tw-shadow-none tw-rounded bg-primary border-primary tw-text-white tw-font-medium"
              label="Add Department"
              icon="pi pi-plus"
              onClick={() => {
                setFormType("add");
                setIsDialogVisible(true);
              }}
            />
            <Button
              type="button"
              icon="pi pi-upload"
              label="Export"
              loading={isExporting}
              className="tw-flex tw-px-9 tw-py-2 tw-rounded bg-secondary border-primary hover:tw-bg-[#3f3c3c] tw-text-white tw-font-medium focus:tw-shadow-none"
              onClick={() => fetchDepartments(page, size, "export")}
            />
          </div>
        </div>
        <div className="card-body tw-relative tw-min-h-80 table-p-0">
          {departmentsLoading ? (
            <div className="tw-h-full tw-w-full tw-bg-white tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
              <ProgressSpinner />
            </div>
          ) : (
            <>
              <DataTableComponent
                rowData={departments}
                columns={departmentColumns}
                customClass="timelog-datatable"
              />

              <Paginator
                first={first}
                rows={size}
                totalRecords={totalRecords} // Set total records for pagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                onPageChange={onPageChange}
              />
            </>
          )}
        </div>
      </div>
      <Dialog
        header={formType === "add" ? "Add Department" : "Update Department"}
        visible={isDialogVisible}
        style={{ width: "20vw" }}
        onHide={() => {
          if (!isDialogVisible) return;
          setIsDialogVisible(false);
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            name: null,
            description: null,
            manager: null,
          }));
          setFormValues((prevFormValues) => ({
            ...prevFormValues,
            name: null,
            description: null,
            manager: null,
          }));
          setFormType("add");
        }}
      >
        <div className="tw-flex tw-flex-col">
          <div className="tw-mt-0 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Department Name</label>
            <InputText
              value={formValues?.name ?? ""}
              className={`${
                formErrors.name ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  name: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      name: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      name: e.target.value,
                    }));
              }}
              placeholder="Enter Department Name"
            />
            {/* {formErrors.supplierName && (
                    <p className="tw-text-red-600 tw-text-xs">
                      {formErrors.supplierName}
                    </p>
                  )} */}
          </div>

          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Manager Name</label>
            <Dropdown
              value={formValues?.manager ?? null}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  manager: null,
                }));
                setFormValues((prevFormValues) => ({
                  ...prevFormValues,
                  manager: e.target.value,
                }));
              }}
              filter
              options={managers}
              optionLabel="displayName"
              placeholder="Select Manager"
              className={`tw-border tw-border-solid ${
                formErrors.manager ? "tw-border-red-600" : "tw-border-gray-300"
              } tw-border-gray-300 tw-rounded-md placeholder:tw-font-normal tw-w-full`}
            />
            {/* {formErrors.countryID && (
                    <p className="tw-text-red-600 tw-text-xs">
                      {formErrors.countryID}
                    </p>
                  )} */}
          </div>
          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <label className="tw-mt-3 tw-font-bold">Description</label>
            <InputText
              value={formValues?.description ?? ""}
              className={`${
                formErrors.description
                  ? "tw-border-red-600"
                  : "tw-border-gray-300"
              } tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal`}
              onChange={(e) => {
                setFormErrors((prevErrors) => ({
                  ...prevErrors,
                  description: null,
                }));
                e.target.value === ""
                  ? setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      description: null,
                    }))
                  : setFormValues((prevFormValues) => ({
                      ...prevFormValues,
                      description: e.target.value,
                    }));
              }}
              placeholder="Enter Description"
            />
            {/* {formErrors.businessNumber && (
                    <p className="tw-text-red-600 tw-text-xs">
                      {formErrors.businessNumber}
                    </p>
                  )} */}
          </div>
          <Button
            label={formType === "add" ? "Add Department" : "Update Department"}
            className="tw-flex tw-px-3 tw-py-2 focus:tw-shadow-none tw-rounded-lg bg-primary border-primary tw-text-white tw-font-medium tw-w-full tw-mt-8"
            onClick={handleAddUpdateDepartment}
            disabled={isAddButtonDisabled}
          />
        </div>
      </Dialog>
      <Dialog
        header={`${
          pendingStatusChange?.isActive ? "Activate" : "Deactivate"
        } Department`}
        draggable={false}
        visible={isStatusDialogVisible}
        style={{ width: "28vw" }}
        onHide={() => {
          setIsStatusDialogVisible(false);
          setStatusChangeReason("");
          setPendingStatusChange(null);
        }}
      >
        <div className="tw-flex tw-flex-col tw-gap-4">
          <p>
            Please provide a reason for{" "}
            {pendingStatusChange?.isActive ? "activating" : "deactivating"} this
            department:
          </p>
          <InputText
            value={statusChangeReason}
            onChange={(e) => {
              setStatusChangeReason(e.target.value);
              setStatusChangeReasonError(null);
            }}
            placeholder="Enter reason..."
            className={`tw-px-[14px] tw-py-[5px] tw-border tw-border-solid tw-border-gray-300 tw-rounded-md tw-h-11 placeholder:tw-font-normal ${
              statusChangeReasonError ? "tw-border-red-500" : ""
            }`}
          />
          {statusChangeReasonError && (
            <small className="tw-text-red-500">{statusChangeReasonError}</small>
          )}
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <Button
              label="Cancel"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none tw-bg-gray-300 hover:tw-bg-gray-400 tw-text-gray-800 tw-font-medium"
              onClick={() => {
                setIsStatusDialogVisible(false);
                setStatusChangeReason("");
                setPendingStatusChange(null);
                setStatusChangeReasonError(null);
              }}
            />
            <Button
              label="Confirm"
              className="tw-px-4 tw-py-2 tw-rounded-lg focus:tw-shadow-none bg-primary border-primary hover:tw-bg-[#02a2db] tw-text-white tw-font-medium"
              onClick={confirmStatusChange}
              disabled={isAddButtonDisabled}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        className="comments-dialog tw-w-[444px]"
        style={{ maxWidth: "620px" }}
        header={() => {
          return (
            <div className="tw-flex tw-flex-col tw-justify-start tw-items-start tw-w-full">
              <span>Status Change History</span>
              <span>({selectedRowData?.name})</span>
            </div>
          );
        }}
        visible={viewHistoryPopup}
        draggable={false}
        onHide={() => {
          if (!viewHistoryPopup) return;
          setViewHistoryPopup(false);
        }}
      >
        <>
          {departmentStatusChangeActivity &&
          departmentStatusChangeActivity.length !== 0 ? (
            <Timeline
              className="tw-p-4"
              align="left"
              marker={customizedMarker}
              content={customizedContent}
              value={events}
            />
          ) : (
            <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
              <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                No History Found
              </p>
            </div>
          )}
        </>
      </Dialog>
    </>
  );
};

export default DepartmentManagement;
